// src/utils/debugUtils.ts
import { logger } from '../lib/logger';

export function debugLoadingState() {
  // Debug logging removed
}

export function monitorNetworkStatus() {
  window.addEventListener('online', () => {
    // Connection restored - no action needed
  });

  window.addEventListener('offline', () => {
    logger.warn('Network connection lost', {
      category: 'Network',
      data: { timestamp: new Date().toISOString() }
    });
  });
}